//import '../App.css';
import React, { useEffect, useRef, useState } from 'react';
import { Routes, Route, useLocation, useNavigate, useParams, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import AuthRoute from './AuthRoute';
import AppRoute from './AppRoute';
import { closeAllModals } from '../redux/actions/action-creator';
import Preloader from '../helper/Preloader';
import { VendorGridSkeleton } from '../components/SkeletonLoader';
import { clearGuestSession, hasAuthenticatedSession, performGuestLogin } from '../utils/guestLogin';
import DeliveryLocationPrompt from '../components/DeliveryLocationPrompt';
import CartPreviewBar from '../components/CartPreviewBar';
import AccountPage from "./../pages/AccountPage";
import LoginPage from "./../pages/LoginPage";
import HomePage from "./../pages/HomePage";
import StoresPage from "./../pages/StoresPage";
import ServiceBookingPage from "./../pages/serviceBooking/ServiceBookingPage";
import StoreCategoryPage from "./../pages/StoreCategoryPage";
import ShopPage from "./../pages/ShopPage";
import ProductDetail from "./../pages/ProductDetail";
import CartPage from "./../pages/CartPage";
import CheckoutPage from "./../pages/CheckoutPage";
import OrdersPage from "./../pages/OrdersPage";
import OrderTrackingPage from "./../pages/OrderTrackingPage";
import AddressPage from "./../pages/AddressPage";
import MyAccountPage from "./../pages/MyAccountPage";
import SduiHomePage from "./../pages/SduiHomePage";
import ContactPage from "./../pages/ContactPage";
import MainPage from "./../pages/MainPage";
import AboutPage from "./../pages/AboutPage";
import ServicesPage from "./../pages/ServicesPage";
import VendorsDeliveryPartnersPage from "./../pages/VendorsDeliveryPartnersPage";
import AdvertiseWithUsPage from "./../pages/AdvertiseWithUsPage";
import BecomeADeliveryPartnerPage from "./../pages/BecomeADeliveryPartnerPage";
import OnboardYourStorePage from "./../pages/OnboardYourStorePage";
import TermsAndConditionsPage from "./../pages/TermsAndConditionsPage";
import PrivacyPolicyPage from "./../pages/PrivacyPolicyPage";
import SupportInfoPage from "./../pages/SupportInfoPage";
import { setPageSeo } from '../utils/seo';

//import useAutoDateUpdate from '../components/Custom_Hooks/useAutoDateUpdate';

const Index = () => {
  const { id } = useParams()
  const dispatch = useDispatch();
  const { userData = null } = useSelector(state => state.auth);
  const modal_state = useSelector(state => state.common.modal_state);
  const location = useLocation();
  const navigate = useNavigate();
  const guestLoginStartedRef = useRef(false);
  const [guestInitializing, setGuestInitializing] = useState(false);
  const [guestLoginFailed, setGuestLoginFailed] = useState(false);
  const hasSession = hasAuthenticatedSession(userData);
  const skipGuestAutoLoginRoutes = ['/login', '/signUp', '/branch_login', '/contact', '/contact-us', '/main-page', '/about-page', '/services', '/vendors-delivery-partners', '/advertise-with-us', '/become-a-delivery-partner', '/onboard-your-store', '/terms-and-conditions', '/privacy-policy', '/free-delivery', '/returns-policy', '/help-center'];
  const shouldAutoGuestLogin = !skipGuestAutoLoginRoutes.includes(location.pathname);
  
  // Auto update current date
  //useAutoDateUpdate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      // List of shortcuts to disable
      if (event.ctrlKey && (event.key === 't' || event.key === 'T')) {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'r') {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'n') {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'p') {
        event.preventDefault();
      } else if (event.ctrlKey && event.key === 'w') {
        event.preventDefault();
      }
      // else if (event.ctrlKey && event.key === 'a') {
      //   event.preventDefault();
      // }
      //  else if (event.ctrlKey && event.key === 'c') {
      //   event.preventDefault();
      // } 
      else if (event.ctrlKey && (event.key === '=' || event.key === '+')) {
        // event.preventDefault();
      } else if (event.ctrlKey && (event.key === '_' || event.key === '-')) {
        // event.preventDefault();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        // if (location.pathname !== `/`) {
        //   navigate(-1);
        // }

        if (Object?.values(modal_state)?.includes(true)) {
          dispatch(closeAllModals());
        }
        else
          if (location.pathname !== '/') {
            navigate(-1);
          }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate, location.pathname, modal_state, dispatch]);

  useEffect(() => {
    if (!shouldAutoGuestLogin || hasSession || guestLoginStartedRef.current) {
      return undefined;
    }

    guestLoginStartedRef.current = true;
    setGuestInitializing(true);
    setGuestLoginFailed(false);

    performGuestLogin(dispatch)
      .then(() => {
        if (location.pathname === '/') {
          navigate('/home', { replace: true });
        }
      })
      .catch((error) => {
        console.warn('Guest login failed', error);
        setGuestLoginFailed(true);
        navigate('/login', { replace: true });
      })
      .finally(() => {
        guestLoginStartedRef.current = false;
        setGuestInitializing(false);
      });

    return undefined;
  }, [dispatch, hasSession, location.pathname, navigate, shouldAutoGuestLogin]);

  useEffect(() => {
    if (location.pathname !== '/login') {
      return undefined;
    }

    guestLoginStartedRef.current = false;
    setGuestLoginFailed(false);

    clearGuestSession();

    return undefined;
  }, [location.pathname]);

  useEffect(() => {
    const getSeoForPath = (path) => {
      const defaultDescription =
        'RGHT NOW connects customers with nearby grocery stores, daily deals, local services, and delivery partners across supported UAE and India markets.';

      if (path === '/' || path === '/home') {
        return {
          title: 'Grocery Stores Near You | RGHT NOW',
          description: 'Shop groceries, daily essentials, and local services from nearby stores on RGHT NOW.',
        };
      }
      if (path === '/stores' || path.startsWith('/stores/')) {
        return {
          title: 'Grocery Stores Near You | RGHT NOW',
          description: 'Browse available grocery stores near your selected delivery location on RGHT NOW.',
        };
      }
      if (path.startsWith('/category') || path.startsWith('/store-category')) {
        return {
          title: 'Daily Deal - Online Grocery Store | RGHT NOW',
          description: 'Explore store categories, daily deals, brands, and recently browsed products on RGHT NOW.',
        };
      }
      if (path.startsWith('/shop')) {
        return {
          title: 'Shop Products Online | RGHT NOW',
          description: 'Search and shop products from available RGHT NOW stores.',
        };
      }
      if (path.startsWith('/productdetail') || path.startsWith('/product-detail')) {
        return { title: 'Product Details | RGHT NOW', description: 'Explore product details, weights, prices and customer reviews on RGHT NOW.' };
      }
      if (path === '/sdui-home') {
        return { title: 'RGHT NOW | Home', description: defaultDescription };
      }
      if (path === '/login') {
        return { title: 'Login | RGHT NOW', description: 'Sign in to your RGHT NOW account.' };
      }
      if (path === '/my-account') {
        return { title: 'My Account | RGHT NOW', description: 'Manage your RGHT NOW profile, orders, and addresses.' };
      }
      if (path === '/contact' || path === '/contact-us') {
        return { title: 'Contact Us | RGHT NOW', description: 'Contact the RGHT NOW team for support, business, and partnership queries.' };
      }
      if (path === '/free-delivery') {
        return { title: 'Free Delivery | RGHT NOW', description: 'Learn how RGHT NOW delivery offers and location-based delivery benefits work.' };
      }
      if (path === '/returns-policy') {
        return { title: 'Returns Policy | RGHT NOW', description: 'Read RGHT NOW return and refund guidance for customer orders.' };
      }
      if (path === '/help-center') {
        return { title: 'Help Center | RGHT NOW', description: 'Find help for RGHT NOW orders, deliveries, accounts, merchants, and support.' };
      }
      if (path === '/main-page') {
        return { title: 'One Platform | RGHT NOW', description: defaultDescription };
      }
      if (path === '/about-page') {
        return { title: 'About Us | RGHT NOW', description: 'Learn about RGHT NOW and its UAE and India marketplace operations.' };
      }
      if (path === '/services') {
        return { title: 'Services | RGHT NOW', description: 'Explore RGHT NOW marketplace services for customers and businesses.' };
      }
      if (path === '/vendors-delivery-partners') {
        return { title: 'Vendors & Delivery Partners | RGHT NOW', description: 'Partner with RGHT NOW as a vendor or delivery partner.' };
      }
      if (path === '/advertise-with-us') {
        return { title: 'Advertise With Us | RGHT NOW', description: 'Advertise your brand or store with RGHT NOW.' };
      }
      if (path === '/become-a-delivery-partner') {
        return { title: 'Become a Delivery Partner | RGHT NOW', description: 'Join RGHT NOW as a delivery partner.' };
      }
      if (path === '/onboard-your-store') {
        return { title: 'Onboard Your Store | RGHT NOW', description: 'Start selling your products and services on RGHT NOW.' };
      }
      if (path === '/terms-and-conditions') {
        return { title: 'Terms and Conditions | RGHT NOW', description: 'Read RGHT NOW terms and conditions.' };
      }
      if (path === '/privacy-policy') {
        return { title: 'Privacy Policy | RGHT NOW', description: 'Read the RGHT NOW privacy policy.' };
      }
      if (path === '/cart') {
        return { title: 'My Basket | RGHT NOW', description: 'Review your RGHT NOW basket before checkout.' };
      }
      if (path === '/checkout') {
        return { title: 'Checkout | RGHT NOW', description: 'Complete your RGHT NOW order.' };
      }
      if (path === '/orders' || path === '/my-order') {
        return { title: 'My Orders | RGHT NOW', description: 'Track and review your RGHT NOW orders.' };
      }
      if (path === '/address-list') {
        return { title: 'Delivery Addresses | RGHT NOW', description: 'Choose or manage your RGHT NOW delivery location.' };
      }

      return {
        title: 'RGHT NOW - Multi-Service Shopping App',
        description: defaultDescription,
      };
    };

    const changeTitleName = () => {
      const path = location.pathname;
      const seo = getSeoForPath(path);

      if (path === '/createmasters') {
        document.title = 'Create Master';
      } else if (path === '/create-master-group') {
        document.title = 'Group Creation';
      }
      else if (path === '/create-master-ledger') {
        document.title = 'Ledger Creation';
      }
      else if (path === '/chart-of-account-accounting-master-group') {
        document.title = 'List of Group(s)';
      }
      else if (path === `/alter_accounting_groupupdate/${id}`) {
        document.title = 'Group Alteration';
      }
     
     
      else if (path === `/create-master-invmas-stockcompany`) {
        document.title = 'Stock Company Creation';
      }
      else if (path === `/create-master-invmas-stockcategory`) {
        document.title = 'Stock Category Creation';
      }
      else if (path === `/create-master-invmas-stockgroup`) {
        document.title = 'Stock Group Creation';
      }
      else if (path === `/chart-of-account-invmas-stockgroup`) {
        document.title = 'List of Stock Group';
      }
      else if (path === `/chartofaccountmasters`) {
        document.title = 'Master List';
      }
      else if (path === `/chart-of-account-accounting-master-ledger`) {
        document.title = 'List of Ledger(s)';
      }
      else {
        setPageSeo({ ...seo, path });
      }
    };
    changeTitleName();
    return () => {
    };
  }, [location, userData, id]);

  console.log("HELLEEEEEOEOOEOE", userData);
  if (guestInitializing || (shouldAutoGuestLogin && !hasSession && !guestLoginFailed)) {
    const showStoresSkeleton = location.pathname.startsWith('/stores');

    return (
      <div className="App">
        {showStoresSkeleton ? <VendorGridSkeleton /> : <Preloader />}
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        
        {/* PUBLIC ROUTES: Inhe bina login ke dekh sakte hain */}
        {/* Agar login hai toh ye routes automatically /home par redirect karenge */}
        <Route element={<AuthRoute />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signUp" element={<AccountPage />} />
        </Route>

        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/main-page" element={<MainPage />} />
        <Route path="/about-page" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/vendors-delivery-partners" element={<VendorsDeliveryPartnersPage />} />
        <Route path="/advertise-with-us" element={<AdvertiseWithUsPage />} />
        <Route path="/become-a-delivery-partner" element={<BecomeADeliveryPartnerPage />} />
        <Route path="/onboard-your-store" element={<OnboardYourStorePage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/free-delivery" element={<SupportInfoPage />} />
        <Route path="/returns-policy" element={<SupportInfoPage />} />
        <Route path="/help-center" element={<SupportInfoPage />} />

        {/* PRIVATE ROUTES: Inke liye Login hona zaroori hai */}
        <Route element={<AppRoute allowedRoles={['USER', 'ADMIN', 'VENDOR']} />}>
          <Route path='/home' element={<HomePage />} />
          <Route path='/sdui-home' element={<SduiHomePage />} />
          <Route path='/service-booking/:screen?' element={<ServiceBookingPage />} />
          <Route path='/stores/:segmentId?' element={<StoresPage />} />
          <Route path='/category/:categorySlug' element={<StoreCategoryPage />} />
          <Route path='/store-category' element={<StoreCategoryPage />} />
          <Route path='/store-category/:storeId' element={<StoreCategoryPage />} />
          <Route path='/shop/:storeSlug/:categorySlug' element={<ShopPage />} />
          <Route path='/shop/:categorySlug' element={<ShopPage />} />
          <Route path='/shop' element={<ShopPage />} />
          <Route path='/productdetail/:productId?' element={<ProductDetail />} />
          <Route path='/product-details' element={<ProductDetail />} />
          <Route path='/product-details-two' element={<ProductDetail />} />
          <Route path='/my-account' element={<MyAccountPage />} />
          <Route path='/address-list' element={<AddressPage />} />
        </Route>

        <Route element={<AppRoute guestRestricted />}>
          <Route path='/cart' element={<CartPage />} />
        </Route>

        {/* RESTRICTED ROUTES: Sirf Admin ya specific role ke liye */}
        <Route element={<AppRoute allowedRoles={['ADMIN']} guestRestricted />}>
          <Route path='/checkout' element={<CheckoutPage />} />
          <Route path='/orders' element={<OrdersPage />} />
          <Route path='/order-tracking' element={<OrderTrackingPage />} />
          <Route path='/my-order' element={<OrdersPage />} />
        </Route>

        {/* FALLBACK: Agar koi route match na ho */}
        <Route path="*" element={<Navigate to="/home" replace />} />
        
      </Routes>
      <DeliveryLocationPrompt enabled={hasSession && /^\/(home|stores|shop|category|store-category|cart|checkout)(\/|$)/.test(location.pathname)} />
      <CartPreviewBar />
    </div>
  );
}
export default Index;
